import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { FormHelperText, FormLabel } from '@mui/material';

type Props = {
  label?: string;
  value: string[];
  options: any[];
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  error?: string;
  onChange: (value: string[]) => void;
};

const MultiSelectField = ({ label, value, options = [], required, disabled, error, onChange }: Props) => {
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value },
    } = event;
    onChange(typeof value === 'string' ? value.split(',') : value);
  };

  return (
    <FormControl fullWidth sx={{ marginTop: 0 }}>
      {label && <FormLabel required={required}>{label}</FormLabel>}
      <Select
        fullWidth
        required={required}
        variant="outlined"
        multiple
        value={value}
        onChange={handleChange}
        size="small"
        margin="dense"
        error={error !== undefined}
        disabled={disabled}
        sx={{ marginTop: 0, marginBottom: 1 }}
        input={<OutlinedInput id="select-multiple-chip" label={''} />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.map((v) => (
              <Chip key={v} label={v} size="small" />
            ))}
          </Box>
        )}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
};

export default MultiSelectField;
